<div class="login-page">

  <div class="login-card">

    <div class="login-box">

      <img class="logo" src="assets/img/emdr logo monochrome white.svg" alt="EMDR therapy logo"/>


      <form class="form-body" [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="new-password">

        <div class="upper-login">
          <div class="inp">
            <input type="text" name="email" formControlName="email" placeholder="Email" id="username" autofocus required>
          </div>
          <div class ="inp">
            <input type="password" name="password" formControlName="password"  autocomplete="new-password" placeholder="Password" id="password" [type]="hide ? 'password' : 'text'" required>
            <button type="button" mat-icon-button matSuffix (click)="hide = !hide" id="eye_button" >
              <mat-icon id="eye_icon">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </div>
        </div>

        <div class="lower-login">

          <div class="login-error" *ngIf="loginError">{{loginError}}</div>

            <button id="Connect" mat-raised-button color="darkGreen" type="submit" >Login!</button>
            <a class="forgot-password" routerLink='/checkEmail'>Forgot Password?</a>
          <!-- <mat-spinner [diameter]="50" *ngIf="isClicked"></mat-spinner> -->
        </div>
      </form>


      <div class="new-us">
        <a routerLink='/registration'>Not a member yet? Sign Up!</a>
      </div>
    </div>

    

    <div class="footer">
      <div class="bottom-nav">
        <a href="#">Home</a>
        <div class="spacer">|</div>
        <a href="#">Contact</a>
        <div class="spacer">|</div>
        <a href="#">Info</a>
      </div>

      <div class="emdr">
        @2021EMDRremote
      </div>

    </div>
  </div>

</div>
